module.exports = __webpack_public_path__ + "img/foodkart.573758f8.svg";